export const createUriForEditor = (monaco, editorName) => {
  return monaco.Uri.parse("inmemory://".concat(editorName));
};
const isModelForEditor = (model, editorName) => {
  return model.uri.authority === editorName;
};
export default isModelForEditor;